import { motion, AnimationProps } from 'framer-motion';

const commonProps: AnimationProps = {
  initial: { opacity: 0.1 },
  animate: { opacity: [0.1, 0.3, 0.1] },
  transition: { duration: 3, repeat: Infinity },
};

const MotionDivHeading = () => {
  return <motion.div className={'h-24 w-1/3 rounded-28 bg-black-100 opacity-10'} {...commonProps}></motion.div>;
};

const MotionDivFirst = () => {
  return (
    <motion.div className={'ml-24 mt-24 h-24 w-1/3 rounded-28 bg-black-100 opacity-10'} {...commonProps}></motion.div>
  );
};

const MotionDivSecound = () => {
  return (
    <motion.div className={'mx-auto h-24 w-[90%] rounded-28 bg-black-100 opacity-10'} {...commonProps}></motion.div>
  );
};

const LoadingCardCollection = () => {
  return (
    <div className=" col-span-full ">
      <div className="col-span-full">
        <MotionDivHeading />
      </div>
      <div className="col-span-full mt-32 flex gap-24">
        <div className="flex h-[260px] w-full flex-col rounded-28 shadow-card sm:w-[300px]">
          <div className="flex flex-1 flex-col justify-between">
            <MotionDivFirst />
            <MotionDivSecound />
            <div className="h-56 gap-8 rounded-b-28 bg-white-15"></div>
          </div>
        </div>
        <div className="hidden h-[260px] w-full flex-col rounded-28 shadow-card sm:flex sm:w-[300px]">
          <div className="flex flex-1 flex-col justify-between">
            <MotionDivFirst />
            <MotionDivSecound />
            <div className="h-56 gap-8 rounded-b-28 bg-white-15"></div>
          </div>
        </div>
        <div className="hidden h-[260px] w-full flex-col rounded-28 shadow-card sm:w-[300px] lg:flex">
          <div className="flex flex-1 flex-col justify-between">
            <MotionDivFirst />
            <MotionDivSecound />
            <div className="h-56 gap-8 rounded-b-28 bg-white-15"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoadingCardCollection;
